'use strict';

/**
 * Unpacks specified properties from an object and returns the remaining properties and the unpacked properties.
 *
 * @template T - The type of the input object.
 * @template U - The type of the keys to be unpacked from the input object.
 * @template Unpacked - The resulting type after unpacking the specified keys.
 * @param {T} props - The input object from which properties will be unpacked.
 * @param {U[]} propKeys - The keys to be unpacked from the input object.
 * @returns {{ rest: Omit<T, U>, unpacked: Pick<T, U> }} - An object containing the remaining properties and the unpacked properties.
 */ function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function unpackProps(props, propKeys) {
    const rest = _extends({}, props);
    const unpacked = propKeys.reduce((result, key)=>{
        delete rest[key];
        return _extends({}, result, {
            [key]: props[key]
        });
    }, {});
    return {
        rest: rest,
        unpacked
    };
}

module.exports = unpackProps;
